import VDivider from './VDivider'

export default {
  VDivider
}



// WEBPACK FOOTER //
// ./src/components/dividers/index.js